export default "__VITE_ASSET__c0008eb3__"